import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';
import { ROUTE_ANALYTICS_PROSECTOR_KNM } from 'CorePackage/MainModule/routes/routes';

import { AnalyticsKnmList } from './AnalyticsKnmList';

export const AnalyticsKnmListPage = () => {
  useTitle('Аналитика. Список КНМ');

  return (
    <Layout withFooter>
      <AnalyticsKnmList isOrganizationAnalytics={window.location.pathname === ROUTE_ANALYTICS_PROSECTOR_KNM} />
    </Layout>
  );
};
